import { render } from "@testing-library/react";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import watsappHeader from "../resources/form/WHATSAPPHEADER.png";
import notificationHeader from "../resources/form/NOTIFICATIONHEADER.png";
import bannerHeader from "../resources/form/BANNERHEADER.png";
import detailsCta from "../resources/form/CTA.png";
import "./form.css";

class Details extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appName: "",
      courseName: "",
      coursePrice: "",
      isEducatorPhoto: false,
      isAppLogo: false,
      color: "red",
      educatorPhoto: "",
      appLogo: "",
      posterType: "",
      contactNumber: "",
    };
  }

  handleValueChange(event, valueType) {
    switch (valueType) {
      case "appName":
        this.setState({ appName: event.target.value });
        break;

      case "courseName":
        this.setState({ courseName: event.target.value });
        break;

      case "coursePrice":
        this.setState({ coursePrice: event.target.value });
        break;

      case "color":
        this.setState({ color: event.target.value });
        break;

      case "contactNumber":
        this.setState({ contactNumber: event.target.value });
        break;

      default:
        break;
    }
  }

  handleChangePage = () => {
    let body = {
      appName: this.state.appName,
      courseName: this.state.courseName,
      coursePrice: this.state.coursePrice,

      contactNumber: this.state.contactNumber,
    };

    var { posterType } = this.props.location.state;
    console.log(posterType);

    if (posterType == "notification" || posterType == "banner") {
      this.state.appName &&
      this.state.courseName &&
      this.state.coursePrice &&
      this.state.color &&
      this.state.isEducatorPhoto == true
        ? fetch("https://hooks.zapier.com/hooks/catch/4460305/byf3yqu/", {
            method: "POST",
            headers: {
              // "Content-Type": 'application/json',
            },
            body: JSON.stringify(body),
          })
            .then((res) => {
              this.props.history.push("/posterOutput", {
                data: this.state,
                posterType: this.props.location.state.posterType,
              });
              console.log(body, "palash reesp");
            })
            .catch((err) => console.log(err))
        : alert("please fill in all the fields");
    } else if (posterType == "watsapp") {
      this.state.appName &&
      this.state.courseName &&
      this.state.coursePrice &&
      this.state.color &&
      this.state.isEducatorPhoto == true &&
      this.state.isAppLogo == true
        ? fetch("https://hooks.zapier.com/hooks/catch/4460305/byf3yqu/", {
            method: "POST",
            headers: {
              // "Content-Type": 'application/json',
            },
            body: JSON.stringify(body),
          })
            .then((res) => {
              this.props.history.push("/posterOutput", {
                data: this.state,
                posterType: this.props.location.state.posterType,
              });
              console.log(body, "palash reesp");
            })
            .catch((err) => console.log(err))
        : alert("please fill in all the fields");
    }
  };

  handleChange(event) {
    this.setState({
      educatorPhoto: URL.createObjectURL(event.target.files[0]),
      isEducatorPhoto: true,
    });
  }

  handleChangeWatsapp(event) {
    this.setState({
      appLogo: URL.createObjectURL(event.target.files[0]),
      isAppLogo: true,
    });
  }

  render() {
    var { posterType } = this.props.location.state;

    const {
      appName,
      courseName,
      coursePrice,

      color,
      contactNumber,
    } = this.state;

    return (
      <>
        <div className="form">
          <img
            src={
              posterType == "watsapp"
                ? watsappHeader
                : posterType == "notification"
                ? notificationHeader
                : posterType == "banner"
                ? bannerHeader
                : ""
            }
            className="formHeader"
          />

          <div className="detailsInput">
            <span id="inputText">App Name*</span>
            <input
              id="appName"
              value={appName}
             
              onChange={(event) => this.handleValueChange(event, "appName")}
            ></input>
            <span id="inputText">Course Name*</span>
            <input
              id="courseName"
              onChange={(event) => this.handleValueChange(event, "courseName")}
              maxLength= "50"
              value={courseName}
            ></input>
            <span id="inputText">Course Price*</span>
            <input
              id="coursePrice"
              onChange={(event) => this.handleValueChange(event, "coursePrice")}
              value={coursePrice}
            ></input>
            <span id="inputText">Educators Photo*</span>
            <input
              id="educatorsPhoto"
              type="file"
              onChange={(event) => this.handleChange(event)}
            ></input>

            {posterType == "watsapp" ? (
              <>
                <span id="inputText">App Logo*</span>
                <input
                  id="appLogo"
                  type="file"
                  onChange={(event) => this.handleChangeWatsapp(event)}
                ></input>

                <span id="inputText">Contact No.*</span>
                <input
                  id="contactNumber"
                  onChange={(event) =>
                    this.handleValueChange(event, "contactNumber")
                  }
                  value={contactNumber}
                ></input>
              </>
            ) : (
              ""
            )}

            <span id="inputText">Poster Colour*</span>
            <select
              onChange={(event) => this.handleValueChange(event, "color")}
              value={color}
            >
              <option value="red">Red</option>
              <option value="blue">Blue</option>
            </select>

            {/* <Link
              to={{
                pathname: "/posterOutput",
                state: { data: this.state, posterType: posterType },
              }}
              style={{ textAlign: "center" }}
            > */}
            <img
              src={detailsCta}
              id="detailsCta"
              onClick={this.handleChangePage}
            />
            {/* </Link> */}
          </div>
        </div>
      </>
    );
  }
}
// handleChange(event) {
//   this.setState({
//     file: URL.createObjectURL(event.target.files[0]),
//   });
// }

// download = () => {
//   domtoimage.toBlob(document.getElementById("test")).then((blob) => {
//     saveAs(blob, "my-node.png");
//   });
// };

export default Details;
